/* eslint-disable */
import DOMPurify from 'dompurify'
import moment from 'moment'
import { WifiHigh } from 'phosphor-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCalendarAlt, FaFileContract, FaRegBuilding } from 'react-icons/fa'
import { GoLocation } from 'react-icons/go'
import { GrInherit } from 'react-icons/gr'
import { IoIosSchool } from 'react-icons/io'
import { IoSpeedometer } from 'react-icons/io5'
import { MdWork } from 'react-icons/md'
import {
  capitalize,
  contractColors,
  experienceOptions,
  remote,
} from '../../../utils'
import * as s from './styles'

const JobInformation = ({ job, card }) => {
  const { t } = useTranslation(['common', 'campaign'], { useSuspense: false })

  const createMarkup = (html) => ({
    __html: DOMPurify.sanitize(html),
  })

  const firstFilters = [
    job?.contractType ? (
      <>
        <FaFileContract
          size={13}
          // dirty fix because it uses the raw value to index a color by key
          color={contractColors[job?.contractType.replace(' ', '_')]}
        />
        {job?.contractType}
      </>
    ) : undefined,
    job?.location ? (
      <>
        <GoLocation size={13} />
        {capitalize(job?.location?.city) ||
          capitalize(job?.location) ||
          'Non renseigné'}
      </>
    ) : undefined,
    job?.schoolLevel?.length ? (
      <>
        <IoIosSchool size={16} />
        {job?.schoolLevel?.length
          ? job?.schoolLevel.map((el) =>
              el === job?.schoolLevel.slice(-1).join()
                ? el + 'ans'
                : el + 'ans - ',
            )
          : 'Non renseigné'}
      </>
    ) : undefined,
    job?.experience?.length ? (
      <>
        <IoSpeedometer size={13} />
        {job?.experience?.length
          ? job?.experience.map((el) =>
              el === job?.experience.slice(-1).join()
                ? experienceOptions(t)[el]
                : experienceOptions(t)[el] + ' / ',
            )
          : 'Non renseigné'}
      </>
    ) : undefined,
    job?.remoteWorking ? (
      <>
        {job?.remoteWorking && (
          <>
            <WifiHigh size={13} />
            <span
              dangerouslySetInnerHTML={createMarkup(
                remote(job?.remoteWorking, t),
              )}
            />
          </>
        )}
      </>
    ) : undefined,
    /* job?.createdAt ? (
      <>
        <FaCalendarAlt size={13} />
        {job?.createdAt ? moment(job.createdAt).fromNow() : t('common:noDate')}
      </>
    ) : undefined,*/
  ].filter(Boolean)

  const secondFilters = [
    job?.sector?.length ? (
      <>
        <FaRegBuilding size={13} />
        {job?.sector?.length
          ? job?.sector.map((el) =>
              el === job?.sector.slice(-1).join() ? el : el + ' - ',
            )
          : 'Non renseigné'}
      </>
    ) : undefined,
    job?.subSector?.length ? (
      <>
        <GrInherit size={13} />
        {job?.subSector?.length
          ? job?.subSector.map((el) =>
              el === job?.subSector.slice(-1).join() ? el : el + ' - ',
            )
          : 'Non renseigné'}
      </>
    ) : undefined,
    job?.jobDomain?.length ? (
      <>
        <MdWork size={15} />
        {job?.jobDomain?.length
          ? job?.jobDomain.map((el) =>
              el === job?.jobDomain.slice(-1).join() ? el : el + ' - ',
            )
          : 'Non renseigné'}
      </>
    ) : undefined,
    job?.subJob?.length ? (
      <>
        <GrInherit size={13} />
        {job?.subJob?.length
          ? job?.subJob.map((el) =>
              el === job?.subJob.slice(-1).join() ? el : el + ' - ',
            )
          : 'Non renseigné'}
      </>
    ) : undefined,
  ].filter(Boolean)

  return (
    <s.OfferInformationWrapper>
      <div className="info-wrapper">
        <span className="filters">
          {firstFilters.map((el) => (
            <div className="inter-filters">{el}</div>
          ))}
        </span>
      </div>
      {!card && (
        <div className="info-wrapper">
          <span className="filters">
            {secondFilters.map((el) => (
              <div className="inter-filters">{el}</div>
            ))}
          </span>
        </div>
      )}
    </s.OfferInformationWrapper>
  )
}

export default JobInformation
